<template>
    <div class="queue-info-ballon" :class="{'hide-queue-ballon':!visible}">Aguarde em breve você será atendido.</div>
    <!-- <li v-else class="queue-info-ballon" :class="{'hide-queue-ballon':true}">O atendimento foi encerrado. Caso precisa de um novo atendimento atualize a página.</li> -->
</template>

<script>
export default {
    name:"queue-wait-ballon",
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        NumberQueue: {},
    },
    data(){
        return {

        }
    }
}
</script>
